import { html } from "lit";
import { addons } from "@storybook/preview-api";
import { formatHtml } from "@trumpf/ux.common-storybook";

const contentTranslations = JSON.stringify({
    category: {
        values: {
            1001: "Betriebsanleitungen",
            1004: "Software-Handbücher & Programmieranleitungen",
        },
    },
    date: {
        label: "Ausgabedatum",
    },
    languages: {
        label: "Sprachen",
        values: {
            en: "English",
            de: "Deutsch",
            fr: "Français",
            it: "Italiano",
        },
    },
    size: {
        label: "Dateigröße",
    },
    cta: {
        label: "Download",
    },
});

const filterTranslations = JSON.stringify({
    languages: {
        placeholder: "Languages",
        values: {
            en: "English",
            de: "Deutsch",
            fr: "Français",
            it: "Italiano",
        },
    },
    "equipment-material": {
        label: "Show sub-equipment documents",
    },
});

export default {
    title: "Components/Stateful Filter & Content/Stateful Content/Stateful Downloads",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-stateful-downloads",
    args: {
        scope: "",
        translations: "",
        url: "",
    },
    argTypes: {
        scope: {
            control: "text",
        },
        translations: {
            control: "Translations | string",
        },
        url: {
            control: "text",
        },
    },
};

addons.getChannel().on("storyChanged", () => {
    window.location.reload();
});

const Template = () => html`
    <ux-iws-stateful-downloads
        scope="mymachine-downloads"
        url="./generated-mock-data/mymachine-downloads-content.json"
        translations="${contentTranslations}"
    ></ux-iws-stateful-downloads>
`;

export const Default = Template.bind({});

const TemplateWithFilter = () => html`
    <div class="ux-row">
        <div class="ux-col-12">
            <ux-iws-stateful-filter
                scope="mymachine-downloads"
                url="./generated-mock-data/mymachine-downloads-filter.json"
                translations="${filterTranslations}"
                disable-tags
            ></ux-iws-stateful-filter>
            <ux-iws-stateful-filter-tags
                scope="mymachine-downloads"
                translations="${filterTranslations}"
                debug
            ></ux-iws-stateful-filter-tags>
        </div>
    </div>
    <div class="ux-row">
        <div class="ux-col-12">
            <hr class="ux-u-d-block ux-u-mt-zero ux-u-mb-xs" />
        </div>
    </div>
    <div class="ux-row">
        <div class="ux-col-12">
            <ux-iws-stateful-downloads
                scope="mymachine-downloads"
                url="./generated-mock-data/mymachine-downloads-content.json"
                translations="${contentTranslations}"
            ></ux-iws-stateful-downloads>
        </div>
    </div>
`;

export const WithFilter = TemplateWithFilter.bind({});
